var React = require('react');

function LongArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M53.3535 4.35355C53.5488 4.15829 53.5488 3.84171 53.3535 3.64645L50.1716 0.464466C49.9763 0.269204 49.6597 0.269204 49.4645 0.464466C49.2692 0.659728 49.2692 0.976311 49.4645 1.17157L52.2929 4L49.4645 6.82843C49.2692 7.02369 49.2692 7.34027 49.4645 7.53553C49.6597 7.7308 49.9763 7.7308 50.1716 7.53553L53.3535 4.35355ZM0 4.5H53V3.5H0V4.5Z","fill":"white"}));
}

LongArrow.defaultProps = {"width":"54","height":"8","viewBox":"0 0 54 8","fill":"none"};

module.exports = LongArrow;

LongArrow.default = LongArrow;
